// Read the scope the backend put in the session token (see goose-backend
// src/auth/auth.py). Used only to decide what to show; the backend still
// enforces every endpoint.
export function getUserScope() {
    const token = localStorage.getItem('token')
    if (!token) return null
    try {
        const part = token.split('.')[1]
        const payload = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')))
        return payload.scope || null
    } catch (e) {
        return null
    }
}

// WPL staff: they see every wind farm and curate their own list.
export function isStaff() {
    const scope = getUserScope()
    return scope === 'employee' || scope === 'developer'
}
